module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_dress-f70fd104e3d93744e7d1226146cf049c.jpg";